const panelMaxSteps = 10;

export const getters = {
    get_panelConfiguredVoices: (state) => {
        return state.panelConfiguredVoices;
    },

    get_voicePreview: (state) => (value) => {
        return `${state.mediaVoicePreview}${value}.mp3`;
    },

    get_voiceIcon: (state) => (value) => {
        return `${state.mediaVoiceIcon}${value}.png`;
    },

    get_panelVoiceSelected: (state) => (id) => {
        return state.panelConfiguredVoices.find(_ => _.id === id);
    },

    get_purchasedVoices: (state) => {
        return state.purchasedVoices;
    },

    get_purchasedVoice: (state) => (id) => {
        return state.purchasedVoices.find(voice => voice.id === id);
    },

    get_isPurchasedVoice: (state) => (id) => {
        const purchasedVoices = state.purchasedVoices;
        const isPurchasedVoices = purchasedVoices.some(voice => voice.id === id);

        return isPurchasedVoices;
    },

    get_panelMinimumTime: (state) => {
        return state.panelMinimumTime;
    },

    get_maximumTime: (state, getters) => {
        return getters.get_panelMinimumTime * panelMaxSteps;
    },

    get_voiceSelectedPrice: (state, getters) => (id, time) => {
        const basePriceVoiceSelected = getters.get_panelVoiceSelected(id).price;

        if (basePriceVoiceSelected === 0) {
            return basePriceVoiceSelected;
        }

        const panelMinimumTime = getters.get_panelMinimumTime;
        const price = basePriceVoiceSelected * time / panelMinimumTime;

        return price;
    },
};
